import Cookies from "js-cookie";
import { API_ENDPOINTS } from "constants/http-endpoints";
import { ApolloClient, from, HttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { createHttpLink } from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";

const authLink = setContext((_, { headers }) => {
    const token = Cookies.get("system_token");
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : ""
        }
    };
});

const getHeaders = () => {
    return {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE",
        authorization: `Bearer ${Cookies.get("system_token")}`
    };
};

const onBoardingHttpLink = new HttpLink({
    uri: API_ENDPOINTS.ONBOARDING,
    headers: getHeaders()
});

const signup = new HttpLink({
    uri: API_ENDPOINTS.SIGNUP,
    headers: getHeaders()
});

const entitlement = new HttpLink({
    uri: API_ENDPOINTS.ENTITLEMENT,
    headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE"
    }
});

const userMgmtHttpLink = new HttpLink({
    uri: API_ENDPOINTS.USER_MGMT_API,
    headers: {
        Authorization: `Bearer ${Cookies.get("system_token")}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE'"
    }
});

const configuratorHttpLink = createHttpLink({
    uri: API_ENDPOINTS.CONFIGURATOR,
    headers: getHeaders()
});

const appPricingHttpLink = createHttpLink({
    uri: API_ENDPOINTS.APP_PRICING
});

export const httpLinkConfigurator = new ApolloClient({
    link: authLink.concat(configuratorHttpLink),
    cache: new InMemoryCache()
});

export const appPricingClient = new ApolloClient({
    link: authLink.concat(appPricingHttpLink),
    cache: new InMemoryCache()
});

export const hostClient = new ApolloClient({
    link: authLink.concat(from([onBoardingHttpLink])),
    cache: new InMemoryCache()
});

const httpInvitationLink = new HttpLink({
    uri: API_ENDPOINTS.Invitation,
    headers: getHeaders()
});

export const inviteClient = new ApolloClient({
    link: from([httpInvitationLink]),
    cache: new InMemoryCache()
});

const workflowLink = new HttpLink({
    uri: API_ENDPOINTS.WORKFLOW,
    headers: getHeaders()
});

export const workflowClient = new ApolloClient({
    link: from([workflowLink]),
    cache: new InMemoryCache()
});

const signupBuilderUploadLink = createUploadLink({
    uri: API_ENDPOINTS.SIGNUP_BUILDER,
    headers: {
        ...getHeaders(),
        "keep-alive": "true"
    }
});

export const httpLinkSignupBuilder = new ApolloClient({
    link: signupBuilderUploadLink,
    cache: new InMemoryCache()
});

const PLGCRMLink = new HttpLink({
    uri: API_ENDPOINTS.PLG_CRM,
    headers: getHeaders()
});

export const plgCRMClient = new ApolloClient({
    link: from([PLGCRMLink]),
    cache: new InMemoryCache()
});

export const signupClient = new ApolloClient({
    link: from([signup]),
    cache: new InMemoryCache()
});

export const entitlementClient = new ApolloClient({
    link: from([entitlement]),
    cache: new InMemoryCache()
});

export const userMgmtClient = new ApolloClient({
    link: from([userMgmtHttpLink]),
    cache: new InMemoryCache()
});